import ticketsReducer from "./features/ticketsSlice";
import venuesReducer from "./features/venuesSlice";
import { configureStore } from "@reduxjs/toolkit";

export default configureStore({
  reducer: {
    tickets: ticketsReducer,
    venues: venuesReducer,
  },
});
